import { render } from "./DuplicateProductModal.vue?vue&type=template&id=78344a92"
import script from "./DuplicateProductModal.vue?vue&type=script&lang=js"
export * from "./DuplicateProductModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__